"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    studentDetailModal: {
        title: 'Students Standard Performance',
        standard: 'Standard',
        assessmentName: 'Assessment Name',
        questions: 'Questions',
        rawScore: 'Raw Score',
        score: 'Score',
        fetchingInformation: 'Fetching Information, please wait a second',
    },
};
